/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	if (typeof execScript === "function")
		execScript(src);
	else
		eval.call(null, src);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader/addScript.js
 ** module id = 3
 ** module chunks = 0
 **/